export const ActionTypes = {
  GET_STORE_INCOME: 'GET_STORE_INCOME',
  ADD_INCOME: 'ADD_INCOME',
  EXPORT_INCOME: 'EXPORT_INCOME',
};
